import React from 'react';
import './copied.css';


function Copied(){
    return(
        <div className="copied">
            &#10004; Copied to clipbord
            
            <span>Add \n in every printf for better visual</span>
        </div>
    )
}

export default Copied;